import { TemplateQuestions } from './components/Shared/hooks/useFetchTemplateQuestions';
import { TargetedRecruitment } from './impact-measurement/pages/types';

export enum Channels {
  DIGITAL = 'digital',
  LINEAR_TV = 'linear_tv',
  SOCIAL = 'social',
  FORCED_EXPOSURE = 'forced_exposure'
}

export enum CampaignStatus {
  DRAFT = 'draft',
  LIVE = 'live',
  COMPLETE = 'complete',
  PENDING = 'pending',
  ERROR = 'error',
  PROOF_SERVICES = 'proof/services',
  SERVICES_DRAFT = 'services/draft'
}

export enum CampaignTypes {
  SERVICE = 'services',
  SOFTWARE = 'software',
  CONNECT = 'connect', // NOTE: we are also referring to this campaign type as custom-targeting as the new name for this, but the legacy app was named connect
  TRACKING_ONLY = 'tracking-only'
}

export type DraftTargetQualification = {
  qual_name: string;
  marketplace_question_id: number;
  answer_type: 'contains' | 'range';
  precodes: string[];
};

export type DraftTargetAudience = {
  target_name: string;
  qualifications: DraftTargetQualification[];
  is_default?: boolean;
};

export type DraftTargetedRecruitment = {
  name: string;
  qualifications: any[];
};

export type FieldValue = {
  label: string;
  name: string;
  value: string;
};

export type Campaign = {
  account_id?: string;
  campaign_data_updated_at: string | null;
  campaign_id: string;
  campaign_name: string;
  campaign_type?: string;
  client_name: string;
  control_survey_id?: number;
  country_language_id: number;
  created_at: string;
  default_question_id?: number;
  default_question_name: string;
  expected_impressions_count: {
    digital: number;
    linear_tv: number;
    social: number;
  };
  draft_settings: {
    [key: string]: any;
    target_audiences?: DraftTargetAudience[];
    targeted_recruitment?: DraftTargetedRecruitment;
    questions: TemplateQuestions;
    baseline_questions: TemplateQuestions;
    ui?: {
      mediaTrackingAck?: boolean;
      targetAudAck?: boolean;
      // Override flag for baseline questions validation
      isBaselineValidationDisabled?: boolean;
    };
    quota_scheme?: string;
    quota_size?: number;
    control_gemini_enabled?: boolean;
    control_survey_enabled?: boolean;
    campaign_version?: number;
    forced_exposure?: {
      creatives_number?: number;
      exposed_sample_size?: number;
    };
  };
  end_date: string;
  errors: any;
  exposed_survey_id?: number;
  industry_id: number;
  salesforce_id?: string | null;
  permission_id: number;
  start_date: string;
  status: CampaignStatus;
  updated_at: string;
  channels: Channels[];
  region?: string;
  targeted_recruitment?: TargetedRecruitment | null;
  is_methodology_mta?: boolean;
  social_configuration?: {
    brand_name: string;
    // handles: string[];
    ads_start_date: string;
    ads_end_date: string;
  };

  // Custom Campaign
  project_manager_user_id?: number;
  product_type?: CampaignTypes;
};

export type TrackingOnlyCampaign = {
  account_id?: string;
  campaign_data_updated_at: string | null;
  campaign_id: string;
  campaign_name: string;
  start_date: string;
  end_date: string;
  permission_id?: number;
  permission_group_id?: number;
  country_language_id: number;
};

export enum DEMOGRAPHICS {
  AGE = 'age',
  GENDER = 'gender',
  EDUCATION = 'education'
}

export type SocialPlatform = {
  id: number;
  social_platform_name: string;
};
